import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../features/store";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { sidebarToggleAction, sidebarCloseAction } from "../features/sliceReducer/interactionReducer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Box from "@material-ui/core/Box";
import KisaLogo from "../assets/images/KISA_logo_basic.svg";
import { Link, useNavigate } from "react-router-dom";
import { logOutAction } from "../features/sliceReducer/authReducer";
import ThemeSwitch from "./ThemeSwitch";
import { StyledSwitch } from "./StyledSwitch";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      height: "80px",
      paddingTop: "8px",
      backgroundColor: theme.palette.gray.main,
    },
    logo: {
      width: "180px",
      height: "100%",
      filter: theme.palette.type === "dark" ? "invert(80%)" : "",
    },

    title: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      color: theme.palette.text.primary,
    },
    greetings: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "14px",
      color: theme.palette.text.secondary,
      "& strong": {
        fontWeight: "bold",
      },
    },
  })
);

const HeaderAppBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();

  const { user } = useSelector((state: RootState) => state.auth);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logOut = () => {
    handleClose();
    dispatch(logOutAction());
    navigate("/login");
  };

  const navMyPage = () => {
    handleClose();
    navigate("/myPage");
  };

  return (
    <Box>
      <AppBar
        position="fixed"
        color="transparent"
        elevation={4}
        style={{}}
        className={classes.container}
      >
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={() => {
              dispatch(sidebarToggleAction());
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography className={classes.title}>
            <Link
              to="/"
              onClick={() => {
                dispatch(sidebarCloseAction());
              }}
            >
              <img src={KisaLogo} alt="Logo" className={classes.logo} />
            </Link>
          </Typography>
          <Box className={classes.greetings}>
            {/* <Box>
              <ThemeSwitch />
            </Box> */}
            <p>
              <strong>{user?.name}</strong>님 안녕하세요.
            </p>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={open}
              onClose={handleClose}
            >
              {user?.userLevel != 8 && <MenuItem onClick={navMyPage}>Profile</MenuItem>}
              <MenuItem onClick={logOut}>LogOut</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default HeaderAppBar;
